import { chakra, Button, Text } from "@chakra-ui/react";
import { fonts } from "theme/themeConfig";
import { colours } from "@shared/ui.design-system";

export const ButtonModel = chakra(Button, {
  baseStyle: {
    p: "8px 12px",
    borderRadius: "2px",
    background: colours.primary.dark,
    color: colours.secondary.light,
    border: "none",
    "&:hover,&:focus": {
      backgroundColor: colours.accent.medium
    }
  }
});

export const PrimaryBtnCopy = chakra(Text, {
  baseStyle: {
    fontFamily: fonts.acuminMedium,
    mt: "0px",
    fontSize: "1.25rem",
    lineHeight: "1.75rem"
  }
});

export const SecondaryBtnCopy = chakra(Text, {
  baseStyle: {
    fontFamily: fonts.acuminMedium,
    mt: "0px",
    fontSize: "1rem",
    lineHeight: "1.5rem"
  }
});
